// extracted by mini-css-extract-plugin
var _1 = "PostStateBarTooltip-module__tooltipButton--NA1oz";
var _2 = "PostStateBarTooltip-module__tooltipContent--nRgG0";
export { _1 as "tooltipButton", _2 as "tooltipContent" }
